
import { defineComponent } from "vue";
import BillBoard from "./homePage/BillBoard.vue";
import FeatureWall from "./homePage/FeatureWall.vue";
// import UsageCase from "./homePage/UsageCase.vue";


export default defineComponent({
    name: "HomePage",
    data() {
        return {};
    },
    components: {
        BillBoard,
        FeatureWall,
        // UsageCase
    },
});
